import React, { useCallback, useEffect } from 'react'

import { useNavigate } from 'react-router';
import DashhwmSpecial from './dashhwmSpecial';

const WMDemoDashboard = () => {
 
    
  return (
    <div>
        <DashhwmSpecial/>
    </div>
  )
}

export default WMDemoDashboard